import React from 'react';
import { Box, Typography, Stack } from '@mui/material';

interface ProfilePageLayoutProps {
    title: string;
    subtitle: string;
    headerMarginBottom?: string;
    searchForm?: React.ReactNode;
    loading?: boolean;
    loadingMessage?: string;
    children?: React.ReactNode;
}

export const ProfilePageLayout: React.FC<ProfilePageLayoutProps> = ({
    title,
    subtitle,
    headerMarginBottom = '30px',
    searchForm,
    loading,
    loadingMessage = 'Loading profile...',
    children,
}) => {
    if (loading) {
        return (
            <Box sx={{ py: '20px', px: { xs: '8px', sm: '16px', md: '25px' } }}>
                <Stack justifyContent="center" alignItems="center" sx={{ height: '50vh' }}>
                    <Typography>{loadingMessage}</Typography>
                </Stack>
            </Box>
        );
    }

    return (
        <Box sx={{ py: '20px', px: { xs: '8px', sm: '16px', md: '25px' } }}>
            <Box sx={{ mb: headerMarginBottom, pl: { xs: '8px', sm: '16px', md: '20px' } }}>
                <Typography variant="h3" component="h1" className="page-title">
                    {title}
                </Typography>
                <Typography variant="subtitle1" className="page-subtitle">
                    {subtitle}
                </Typography>
            </Box>

            {searchForm}

            {children}
        </Box>
    );
};